import { GenericError } from '@auth0/auth0-spa-js';
import { useRouteError } from 'react-router-dom';

import { ErrorAuthorization } from '@packages/fenrir/feedback/errors/error-authorization';
import { ErrorMessage } from '@packages/fenrir/feedback/errors/error-message';
import { PageContainerRoot } from '@packages/fenrir/page-blocks/page-container/page-container-root';
import { PagePlain } from '@packages/fenrir/pages/page-plain';

import { signout } from '../../../auth/signout';

// TODO: S2CX-15999: Move hard coded text to translations when @platform/core/locale/i18n is enabled
export const IdentityErrorElement = () => {
  const err = useRouteError();

  // If not a GenericError,  bubble-up the error, not an authentication error
  // GenericError: Thrown when network requests to the Auth server fail.
  if (!(err instanceof GenericError)) throw err;

  const errorMessage = (
    <ErrorMessage>
      {err.error}
      <br />
      {err.error_description}
    </ErrorMessage>
  );

  const signOutAction = {
    label: 'Sign out',
    onClick: () => signout(),
  };

  return (
    <PagePlain>
      <PageContainerRoot>
        <ErrorAuthorization
          errorMessages={errorMessage}
          actionButton={signOutAction}
        />
      </PageContainerRoot>
    </PagePlain>
  );
};
